import withLayout from './withLayout';

export { useRegisterFullWidthSlot } from './FullWidthSlotContext';
export type { SetFullWidthSlot } from './FullWidthSlotContext';
export type { LayoutContentWidth, WithLayoutOptions } from './withLayout';

export default withLayout;
